import { render, staticRenderFns } from "./TransferCorrect.vue?vue&type=template&id=56f11cd8&scoped=true&"
import script from "./TransferCorrect.vue?vue&type=script&lang=js&"
export * from "./TransferCorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f11cd8",
  null
  
)

export default component.exports